module.exports = __webpack_public_path__ + "img/dark-logo.b7db03a2.png";